import LocationOnIcon from '@mui/icons-material/LocationOn';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { AddressValue } from './LocationHelpers';
import { MapSearch } from '../../../../../components/molecules/MapSearch';
import { AddressDataType } from '../../../../../components/organisms/StructureAddress';

export const GoogleLookupField: React.FC<{
  fields: AddressValue;
  onSelect: (value: AddressDataType) => void;
}> = ({ fields, onSelect }) => (
  <Box>
    <MapSearch
      label="Search address"
      selectedValue={fields.googleAddress}
      addressData={{ ...fields, addressType: 'Service' }}
      onChange={onSelect}
    />
    <Typography sx={{ fontSize: '10px', color: 'text.secondary', mt: 0.75 }}>
      Pick a result to populate the address, then Save.
    </Typography>
  </Box>
);

export const GoogleLookupUnavailable: React.FC = () => (
  <Box sx={{ py: 2, textAlign: 'center' }}>
    <LocationOnIcon sx={{ color: 'text.secondary', fontSize: 28, mb: 0.5 }} />
    <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
      Google Address Lookup is unavailable in this environment.
    </Typography>
    <Typography sx={{ fontSize: '11px', color: 'text.secondary', mt: 0.5 }}>
      Use Manual Entry to update the address.
    </Typography>
  </Box>
);
